"use strict";
/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Api = exports.HttpClient = exports.ContentType = exports.FractalSdkTournamentLeaderboardType = exports.FractalSdkTournamentGetLeaderboardRequestDirection = exports.FractalSdkSolanaGetForSaleItemsRequestSortField = exports.FractalSdkSolanaDirection = exports.FractalSdkCommonChain = void 0;
var FractalSdkCommonChain;
(function (FractalSdkCommonChain) {
    FractalSdkCommonChain["UNKNOWN"] = "UNKNOWN";
    FractalSdkCommonChain["ETH"] = "ETH";
    FractalSdkCommonChain["SOLANA"] = "SOLANA";
    FractalSdkCommonChain["POLYGON"] = "POLYGON";
})(FractalSdkCommonChain = exports.FractalSdkCommonChain || (exports.FractalSdkCommonChain = {}));
var FractalSdkSolanaDirection;
(function (FractalSdkSolanaDirection) {
    FractalSdkSolanaDirection["ASCENDING"] = "ASCENDING";
    FractalSdkSolanaDirection["DESCENDING"] = "DESCENDING";
})(FractalSdkSolanaDirection = exports.FractalSdkSolanaDirection || (exports.FractalSdkSolanaDirection = {}));
var FractalSdkSolanaGetForSaleItemsRequestSortField;
(function (FractalSdkSolanaGetForSaleItemsRequestSortField) {
    FractalSdkSolanaGetForSaleItemsRequestSortField["LIST_TIME"] = "LIST_TIME";
    FractalSdkSolanaGetForSaleItemsRequestSortField["PRICE"] = "PRICE";
})(FractalSdkSolanaGetForSaleItemsRequestSortField = exports.FractalSdkSolanaGetForSaleItemsRequestSortField || (exports.FractalSdkSolanaGetForSaleItemsRequestSortField = {}));
var FractalSdkTournamentGetLeaderboardRequestDirection;
(function (FractalSdkTournamentGetLeaderboardRequestDirection) {
    FractalSdkTournamentGetLeaderboardRequestDirection["DESC"] = "DESC";
    FractalSdkTournamentGetLeaderboardRequestDirection["ASC"] = "ASC";
})(FractalSdkTournamentGetLeaderboardRequestDirection = exports.FractalSdkTournamentGetLeaderboardRequestDirection || (exports.FractalSdkTournamentGetLeaderboardRequestDirection = {}));
var FractalSdkTournamentLeaderboardType;
(function (FractalSdkTournamentLeaderboardType) {
    FractalSdkTournamentLeaderboardType["UNKNOWN"] = "UNKNOWN";
    FractalSdkTournamentLeaderboardType["AGGREGATE"] = "AGGREGATE";
    FractalSdkTournamentLeaderboardType["HIGHSCORE"] = "HIGHSCORE";
})(FractalSdkTournamentLeaderboardType = exports.FractalSdkTournamentLeaderboardType || (exports.FractalSdkTournamentLeaderboardType = {}));
var ContentType;
(function (ContentType) {
    ContentType["Json"] = "application/json";
    ContentType["FormData"] = "multipart/form-data";
    ContentType["UrlEncoded"] = "application/x-www-form-urlencoded";
})(ContentType = exports.ContentType || (exports.ContentType = {}));
class HttpClient {
    constructor(apiConfig = {}) {
        this.baseUrl = "https://api.fractal.is";
        this.securityData = null;
        this.abortControllers = new Map();
        this.customFetch = (...fetchParams) => fetch(...fetchParams);
        this.baseApiParams = {
            credentials: "same-origin",
            headers: {},
            redirect: "follow",
            referrerPolicy: "no-referrer",
        };
        this.setSecurityData = (data) => {
            this.securityData = data;
        };
        this.contentFormatters = {
            [ContentType.Json]: (input) => input !== null && (typeof input === "object" || typeof input === "string") ? JSON.stringify(input) : input,
            [ContentType.FormData]: (input) => Object.keys(input || {}).reduce((formData, key) => {
                const property = input[key];
                formData.append(key, property instanceof Blob
                    ? property
                    : typeof property === "object" && property !== null
                        ? JSON.stringify(property)
                        : `${property}`);
                return formData;
            }, new FormData()),
            [ContentType.UrlEncoded]: (input) => this.toQueryString(input),
        };
        this.createAbortSignal = (cancelToken) => {
            if (this.abortControllers.has(cancelToken)) {
                const abortController = this.abortControllers.get(cancelToken);
                if (abortController) {
                    return abortController.signal;
                }
                return void 0;
            }
            const abortController = new AbortController();
            this.abortControllers.set(cancelToken, abortController);
            return abortController.signal;
        };
        this.abortRequest = (cancelToken) => {
            const abortController = this.abortControllers.get(cancelToken);
            if (abortController) {
                abortController.abort();
                this.abortControllers.delete(cancelToken);
            }
        };
        this.request = (_a) => __awaiter(this, void 0, void 0, function* () {
            var { body, secure, path, type, query, format, baseUrl, cancelToken } = _a, params = __rest(_a, ["body", "secure", "path", "type", "query", "format", "baseUrl", "cancelToken"]);
            const secureParams = ((typeof secure === "boolean" ? secure : this.baseApiParams.secure) &&
                this.securityWorker &&
                (yield this.securityWorker(this.securityData))) ||
                {};
            const requestParams = this.mergeRequestParams(params, secureParams);
            const queryString = query && this.toQueryString(query);
            const payloadFormatter = this.contentFormatters[type || ContentType.Json];
            const responseFormat = format || requestParams.format;
            return this.customFetch(`${baseUrl || this.baseUrl || ""}${path}${queryString ? `?${queryString}` : ""}`, Object.assign(Object.assign({}, requestParams), { headers: Object.assign(Object.assign({}, (type && type !== ContentType.FormData ? { "Content-Type": type } : {})), (requestParams.headers || {})), signal: cancelToken ? this.createAbortSignal(cancelToken) : void 0, body: typeof body === "undefined" || body === null ? null : payloadFormatter(body) })).then((response) => __awaiter(this, void 0, void 0, function* () {
                const r = response;
                r.data = null;
                r.error = null;
                const data = !responseFormat
                    ? r
                    : yield response[responseFormat]()
                        .then((data) => {
                        if (r.ok) {
                            r.data = data;
                        }
                        else {
                            r.error = data;
                        }
                        return r;
                    })
                        .catch((e) => {
                        r.error = e;
                        return r;
                    });
                if (cancelToken) {
                    this.abortControllers.delete(cancelToken);
                }
                if (!response.ok)
                    throw data;
                return data;
            }));
        });
        Object.assign(this, apiConfig);
    }
    encodeQueryParam(key, value) {
        const encodedKey = encodeURIComponent(key);
        return `${encodedKey}=${encodeURIComponent(typeof value === "number" ? value : `${value}`)}`;
    }
    addQueryParam(query, key) {
        return this.encodeQueryParam(key, query[key]);
    }
    addArrayQueryParam(query, key) {
        const value = query[key];
        return value.map((v) => this.encodeQueryParam(key, v)).join("&");
    }
    toQueryString(rawQuery) {
        const query = rawQuery || {};
        const keys = Object.keys(query).filter((key) => "undefined" !== typeof query[key]);
        return keys
            .map((key) => (Array.isArray(query[key]) ? this.addArrayQueryParam(query, key) : this.addQueryParam(query, key)))
            .join("&");
    }
    addQueryParams(rawQuery) {
        const queryString = this.toQueryString(rawQuery);
        return queryString ? `?${queryString}` : "";
    }
    mergeRequestParams(params1, params2) {
        return Object.assign(Object.assign(Object.assign(Object.assign({}, this.baseApiParams), params1), (params2 || {})), { headers: Object.assign(Object.assign(Object.assign({}, (this.baseApiParams.headers || {})), (params1.headers || {})), ((params2 && params2.headers) || {})) });
    }
}
exports.HttpClient = HttpClient;
/**
 * @title Fractal API
 * @version 1.0
 * @baseUrl https://api.fractal.is
 */
class Api extends HttpClient {
    constructor() {
        super(...arguments);
        this.transaction = {
            /**
             * @description Generates a url and code where players can approve a transaction signing request. Requires project API token.
             *
             * @tags TransactionService
             * @name Authorize
             * @summary authorizeTransaction
             * @request POST:/sdk/transaction/authorize
             * @secure
             */
            authorize: (body, params = {}) => this.request(Object.assign({ path: `/sdk/transaction/authorize`, method: "POST", body: body, secure: true, type: ContentType.Json, format: "json" }, params)),
            /**
             * @description Returns the transaction signanture once the user has signed the transaction. Requires project API token.
             *
             * @tags TransactionService
             * @name GetSignedResult
             * @summary getSignedResult
             * @request GET:/sdk/transaction/signed_result
             * @secure
             */
            getSignedResult: (query, params = {}) => this.request(Object.assign({ path: `/sdk/transaction/signed_result`, method: "GET", query: query, secure: true, format: "json" }, params)),
        };
        this.v1 = {
            /**
             * @description Syncs an item's off-chain metadata. Requires project API token.
             *
             * @tags AdminService
             * @name SyncItemMetadata
             * @summary syncMetadata
             * @request POST:/sdk/v1/admin/item/{id}/sync_metadata
             * @secure
             */
            syncItemMetadata: (id, params = {}) => this.request(Object.assign({ path: `/sdk/v1/admin/item/${id}/sync_metadata`, method: "POST", secure: true, format: "json" }, params)),
            /**
             * @description Update an item's off-chain metadata. Requires project API token.
             *
             * @tags AdminService
             * @name UpdateItemMetadata
             * @summary updateMetadata
             * @request PATCH:/sdk/v1/admin/item/{id}/update_metadata
             * @secure
             */
            updateItemMetadata: (id, args, params = {}) => this.request(Object.assign({ path: `/sdk/v1/admin/item/${id}/update_metadata`, method: "PATCH", body: args, secure: true, type: ContentType.Json, format: "json" }, params)),
            /**
             * @description Returns whether an item is for sale or not. Requires project API token.
             *
             * @tags SolanaMarketplaceService
             * @name IsForSale
             * @summary isForSale
             * @request GET:/sdk/v1/marketplace/solana/item/{id}/for_sale_state
             * @secure
             */
            isForSale: (id, params = {}) => this.request(Object.assign({ path: `/sdk/v1/marketplace/solana/item/${id}/for_sale_state`, method: "GET", secure: true, format: "json" }, params)),
            /**
             * @description Returns a project's items for sale on Fractal's marketplace. Requires project API token.
             *
             * @tags SolanaMarketplaceService
             * @name GetForSaleItems
             * @summary getForSaleItems
             * @request GET:/sdk/v1/marketplace/solana/items/for_sale
             * @secure
             */
            getForSaleItems: (query, params = {}) => this.request(Object.assign({ path: `/sdk/v1/marketplace/solana/items/for_sale`, method: "GET", query: query, secure: true, format: "json" }, params)),
            /**
             * @description Generates a buy transaction for a Solana token listed on Fractal's marketplace.
             *
             * @tags SolanaTransactionService
             * @name TokenBuyTransaction
             * @summary buy
             * @request GET:/sdk/v1/marketplace/solana/token/buy
             */
            tokenBuyTransaction: (query, params = {}) => this.request(Object.assign({ path: `/sdk/v1/marketplace/solana/token/buy`, method: "GET", query: query, format: "json" }, params)),
            /**
             * @description Generates a transaction to cancel a listing for a Solana token on Fractal's marketplace.
             *
             * @tags SolanaTransactionService
             * @name TokenCancelSellTransaction
             * @summary cancelSell
             * @request GET:/sdk/v1/marketplace/solana/token/cancel_sell
             */
            tokenCancelSellTransaction: (query, params = {}) => this.request(Object.assign({ path: `/sdk/v1/marketplace/solana/token/cancel_sell`, method: "GET", query: query, format: "json" }, params)),
            /**
             * @description Generates a sell transaction for a Solana token to be listed on Fractal's marketplace.
             *
             * @tags SolanaTransactionService
             * @name TokenSellTransaction
             * @summary sell
             * @request GET:/sdk/v1/marketplace/solana/token/sell
             */
            tokenSellTransaction: (query, params = {}) => this.request(Object.assign({ path: `/sdk/v1/marketplace/solana/token/sell`, method: "GET", query: query, format: "json" }, params)),
            /**
             * @description Obtain a summary of Fractal NFTs (the snowflakes) held by the user. Requires user access token with the following scope: items:read. The attributes field will give you the maximum and minimum values of the attributes given all the NFTs. The factions field gives a count of the number of flakes in each faction. Hence giving benefits to Hexa holders simply amounts to checking that factions.Hexa >= 1. Giving benefits to any Fractal NFT holder amounts to check that at least one of the faction is non-zero. In terms of rarirty for factions Hexa > Penta > Quad > Tri. The metagame allows participant to power up their Fractals, so one would typically check the Power.max >= threshold.
             *
             * @tags MetagameService
             * @name GetFlakesSummary
             * @summary getFlakesSummary
             * @request GET:/sdk/v1/metagame/flakes_summary
             * @secure
             */
            getFlakesSummary: (params = {}) => this.request(Object.assign({ path: `/sdk/v1/metagame/flakes_summary`, method: "GET", secure: true, format: "json" }, params)),
            /**
             * @description Creates a mint transaction. Requires project API token and additonal setup. Please contact our dev team if you'd like to use this feature.
             *
             * @tags ExperimentalService
             * @name CreateMintTransaction
             * @summary createMintTransaction
             * @request POST:/sdk/v1/mint
             * @secure
             */
            createMintTransaction: (body, params = {}) => this.request(Object.assign({ path: `/sdk/v1/mint`, method: "POST", body: body, secure: true, type: ContentType.Json, format: "json" }, params)),
            /**
             * @description Returns details about a given score. Requires project API token.
             *
             * @tags TournamentService
             * @name GetScore
             * @summary getScore
             * @request GET:/sdk/v1/score/{id}
             * @secure
             */
            getScore: (id, params = {}) => this.request(Object.assign({ path: `/sdk/v1/score/${id}`, method: "GET", secure: true, format: "json" }, params)),
            /**
             * @description Returns the leaderboard for a given tournament. By default, returns scores between the tournament start and end times. Use startTime and endTime get scores for another time frame. Requires project API token.
             *
             * @tags TournamentService
             * @name GetLeaderboard
             * @summary getLeaderboard
             * @request GET:/sdk/v1/tournament/{tournamentId}/leaderboard
             * @secure
             */
            getLeaderboard: (tournamentId, query, params = {}) => this.request(Object.assign({ path: `/sdk/v1/tournament/${tournamentId}/leaderboard`, method: "GET", query: query, secure: true, format: "json" }, params)),
            /**
             * @description Creates a score for a given tournament. Requires project API token.
             *
             * @tags TournamentService
             * @name CreateScore
             * @summary createScore
             * @request POST:/sdk/v1/tournament/{tournamentId}/score
             * @secure
             */
            createScore: (tournamentId, score, params = {}) => this.request(Object.assign({ path: `/sdk/v1/tournament/${tournamentId}/score`, method: "POST", body: score, secure: true, type: ContentType.Json, format: "json" }, params)),
            /**
             * @description Returns the latest scores for a given tournament. Requires project API token.
             *
             * @tags TournamentService
             * @name GetLatestScores
             * @summary getLatestScores
             * @request GET:/sdk/v1/tournament/{tournamentId}/scores
             * @secure
             */
            getLatestScores: (tournamentId, query, params = {}) => this.request(Object.assign({ path: `/sdk/v1/tournament/${tournamentId}/scores`, method: "GET", query: query, secure: true, format: "json" }, params)),
            /**
             * @description Returns a map of user's scores per score types. Requires project API token.
             *
             * @tags TournamentService
             * @name GetExternalUserScores
             * @summary getExternalUserScores
             * @request GET:/sdk/v1/tournament/{tournamentId}/scores/{externalUserId}
             * @secure
             */
            getExternalUserScores: (tournamentId, externalUserId, query, params = {}) => this.request(Object.assign({ path: `/sdk/v1/tournament/${tournamentId}/scores/${externalUserId}`, method: "GET", query: query, secure: true, format: "json" }, params)),
            /**
             * @description Returns a user's total score for a given tournament. Requires project API token.
             *
             * @tags TournamentService
             * @name GetUserScoresTotal
             * @summary getUserScoresTotal
             * @request GET:/sdk/v1/tournament/{tournamentId}/scores_total/{userId}
             * @secure
             */
            getUserScoresTotal: (tournamentId, userId, query, params = {}) => this.request(Object.assign({ path: `/sdk/v1/tournament/${tournamentId}/scores_total/${userId}`, method: "GET", query: query, secure: true, format: "json" }, params)),
            /**
             * @description Returns coins held in a given wallet. Requires user access token with the following scope: coins:read
             *
             * @tags WalletService
             * @name GetCoins
             * @summary getCoins
             * @request GET:/sdk/v1/wallet/coins
             * @secure
             */
            getCoins: (params = {}) => this.request(Object.assign({ path: `/sdk/v1/wallet/coins`, method: "GET", secure: true, format: "json" }, params)),
            /**
             * @description Returns info about a given Fractal wallet. Requires user access token with the following scope: identify
             *
             * @tags WalletService
             * @name GetInfo
             * @summary getInfo
             * @request GET:/sdk/v1/wallet/info
             * @secure
             */
            getInfo: (params = {}) => this.request(Object.assign({ path: `/sdk/v1/wallet/info`, method: "GET", secure: true, format: "json" }, params)),
            /**
             * @description Returns items held in a given wallet. Requires user access token with the following scope: items:read
             *
             * @tags WalletService
             * @name GetWalletItems
             * @summary getItems
             * @request GET:/sdk/v1/wallet/items
             * @secure
             */
            getWalletItems: (params = {}) => this.request(Object.assign({ path: `/sdk/v1/wallet/items`, method: "GET", secure: true, format: "json" }, params)),
        };
        this.v2 = {
            /**
             * No description
             *
             * @tags MarketplaceService
             * @name GetCollections
             * @request GET:/sdk/v2/marketplace/collections
             * @secure
             */
            getCollections: (params = {}) => this.request(Object.assign({ path: `/sdk/v2/marketplace/collections`, method: "GET", secure: true, format: "json" }, params)),
            /**
             * @description Returns listings for a given token. Requires project API token.
             *
             * @tags MarketplaceService
             * @name GetTokenListings
             * @summary GetListings
             * @request GET:/sdk/v2/marketplace/{chain}/item/{address}/listings
             * @secure
             */
            getTokenListings: (chain, address, params = {}) => this.request(Object.assign({ path: `/sdk/v2/marketplace/${chain}/item/${address}/listings`, method: "GET", secure: true, format: "json" }, params)),
        };
    }
}
exports.Api = Api;
